import { Icon } from '@iconify/react';

function App(props) {

  var allStyles = props.style;
  var iconColorPointer = props.iconColorPointer;

  if (allStyles.icon){
    var height = '20px';
    if (allStyles.iconHeight){
      height = allStyles.iconHeight;
    }
    var width = '20px';
    if (allStyles.iconWidth){
      width = allStyles.iconWidth;
    }
    var s = {};
    if (allStyles.iconRotation){
      s.transform = 'rotate('+allStyles.iconRotation + 'deg)';
    }
    var iconColorPointerAct = 'iconColor';
    if (iconColorPointer){
      iconColorPointerAct = iconColorPointer;
    }
    if (allStyles[iconColorPointerAct]){
      s.color = allStyles[iconColorPointerAct]
    }

    if (!allStyles.hW){
      return <Icon height={height} icon={allStyles.icon} style={s}/>    
    }else if (allStyles.hW === 'w'){
      return <Icon width={width} icon={allStyles.icon} style={s}/>    
    }else if (allStyles.hW === 'hw'){
      return <Icon width={width} height={height} icon={allStyles.icon} style={s}/>    
    }
//      
  }
  return null;

}

export default App;
